import React, { useState, useEffect } from 'react';

const JobContext = React.createContext();

const initialJob = { campaignName:'',etkFlag:null, messageText:'',toBeSaved:false};

export const JobProvider = ({ children }) => {
  const [currentJob, setCurrentJob] = useState(initialJob);
  return (
    <JobContext.Provider
      value={{
        currentJob,
        setCurrentJob
      }}
    >
      {children}
    </JobContext.Provider>
  );
};

export const useJob = () => React.useContext(JobContext);
